
import React from 'react';
import styles from '../landing.module.scss';
import { FaGamepad, FaBuilding, FaChartBar } from 'react-icons/fa';

const TargetAudience = () => {
    const audience = [
        {
            title: "Indie VR Developers",
            icon: FaGamepad,
            variant: "", // Default (Red/Pink from theme)
            points: [
                "Validate ideas",
                "Optimize keywords",
                "Compete with larger studios"
            ]
        },
        {
            title: "Publishers & Studios",
            icon: FaBuilding,
            variant: "blue",
            points: [
                "Track portfolios",
                "Monitor competitors",
                "Follow market shifts"
            ]
        },
        {
            title: "Agencies & Consultants",
            icon: FaChartBar,
            variant: "green",
            points: [
                "Generate market reports",
                "Deliver ASO insights",
                "For high-value clients"
            ]
        }
    ];

    return (
        <section className={styles.targetAudienceSection}>
            <div className={styles.container}>
                <div className={styles.sectionHeader}>
                    <h2>Built for VR teams who need market clarity</h2>
                </div>

                <div className={styles.audienceGrid}>
                    {audience.map((item, index) => (
                        <div key={index} className={`${styles.audienceCard} ${styles[item.variant]}`}>
                            <div className={styles.cardIcon}>
                                <item.icon />
                            </div>
                            <h3>{item.title}</h3>
                            <ul>
                                {item.points.map((point, idx) => (
                                    <li key={idx}>{point}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TargetAudience;
